import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

export interface Props extends SvgIconProps {}

const InformationIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={16} height={17} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 0.5C6.41775 0.5 4.87103 0.969192 3.55544 1.84824C2.23985 2.72729 1.21447 3.97672 0.608967 5.43853C0.00346627 6.90034 -0.15496 8.50887 0.153721 10.0607C0.462403 11.6126 1.22433 13.038 2.34315 14.1569C3.46197 15.2757 4.88743 16.0376 6.43928 16.3463C7.99113 16.655 9.59966 16.4965 11.0615 15.891C12.5233 15.2855 13.7727 14.2602 14.6518 12.9446C15.5308 11.629 16 10.0822 16 8.5C16 7.44942 15.7931 6.40914 15.391 5.43853C14.989 4.46793 14.3997 3.58601 13.6569 2.84315C12.914 2.10028 12.0321 1.511 11.0615 1.10896C10.0909 0.706926 9.05058 0.5 8 0.5ZM8 14.9C6.7342 14.9 5.49683 14.5246 4.44435 13.8214C3.39188 13.1182 2.57157 12.1186 2.08717 10.9492C1.60277 9.77973 1.47603 8.4929 1.72298 7.25142C1.96992 6.00994 2.57946 4.86957 3.47452 3.97452C4.36958 3.07946 5.50995 2.46992 6.75142 2.22297C7.9929 1.97603 9.27973 2.10277 10.4492 2.58717C11.6186 3.07157 12.6182 3.89188 13.3214 4.94435C14.0246 5.99682 14.4 7.2342 14.4 8.5C14.4 10.1974 13.7257 11.8252 12.5255 13.0255C11.3253 14.2257 9.69739 14.9 8 14.9Z"
        fill="currentColor"
      />
      <path
        d="M8 6.1C8.44183 6.1 8.8 5.74183 8.8 5.3C8.8 4.85817 8.44183 4.5 8 4.5C7.55817 4.5 7.2 4.85817 7.2 5.3C7.2 5.74183 7.55817 6.1 8 6.1Z"
        fill="currentColor"
      />
      <path
        d="M8 6.9C7.78783 6.9 7.58435 6.98428 7.43432 7.13431C7.28429 7.28434 7.2 7.48783 7.2 7.7V11.7C7.2 11.9122 7.28429 12.1157 7.43432 12.2657C7.58435 12.4157 7.78783 12.5 8 12.5C8.21218 12.5 8.41566 12.4157 8.56569 12.2657C8.71572 12.1157 8.8 11.9122 8.8 11.7V7.7C8.8 7.48783 8.71572 7.28434 8.56569 7.13431C8.41566 6.98428 8.21218 6.9 8 6.9Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default InformationIcon;
